import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Button, Stack, Tooltip, Typography, useTheme } from '@mui/material';

export const SideNavButton = ({ icon, label, isActive, onClick, onMouseOver, tooltip, badgeCount, imgUrl }) => {
  const theme = useTheme(); // Get the theme object

  return (
    <Tooltip title={tooltip}>
      <Stack direction="column" alignItems="center" onClick={onClick} onMouseOver={onMouseOver} sx={{ width: '100%' }}>
        <Button
          disableElevation={true}
          variant={isActive ? 'contained' : 'text'}
          sx={{
            borderRadius: '24px',
            padding: '5px 0 5px 0',
            width: '100%',
            textAlign: 'center',
            boxSizing: 'content-box',
            boxShadow: 0,
            height: 24,
            color: isActive ? theme.palette.getContrastText(theme.palette.primary.main) : theme.palette.text.primary,
          }}
        >
          <Badge badgeContent={badgeCount} color="info" invisible={badgeCount <= 0}>
            {icon && <FontAwesomeIcon icon={icon} style={{ height: '24px' }} size={'2x'} fixedWidth />}
            {imgUrl && <img src={imgUrl} alt={label} style={{ height: '2rem' }} />}
          </Badge>
        </Button>

        {label && <Typography variant="caption">{label}</Typography>}
      </Stack>
    </Tooltip>
  );
};
